import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['character', 'size', 'sizeLabel'];

  updateSize() {
    this.sizeLabelTarget.textContent = `${this.sizeTarget.value} ft`;
  }

  confirm(event) {
    event.preventDefault();
    if (!this.element.reportValidity()) return;
    const option = this.characterTarget.selectedOptions[0];
    this.dispatch('confirm', {
      detail: {
        type: 'character',
        placeableType: 'Character',
        placeableId: Number(option.value),
        name: option.textContent,
        avatarUrl: option.dataset.avatarUrl,
        sizeFeet: Number(this.sizeTarget.value)
      }
    });
  }
}
